import { gql } from '@apollo/client';

const REMOVE_FAVORITE_RESOURCE = gql`
  mutation deleteFavorite($data: FavoriteDeleteInput!) {
    deleteFavorite(data: $data) {
      id
    }
  }
`;

export default REMOVE_FAVORITE_RESOURCE;
